<script setup lang="ts">
defineProps<{ article?: CrystallizeArticle | null }>()

definePageMeta({
  name: 'about-index',
  theme: 'blurple',
})
</script>

<template>
  <NettbutikkAboutPage v-if="article" :article="article" />
</template>
